/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {switchJobs} from '../api'

export const useMutationSwitchJobs = createReactQueryMutationHook('switchJobs', switchJobs)
